import { useMe } from "./api"

/**
 * Capability flags for the signed-in seller. Unknown (loading, or a backend
 * that predates capabilities) counts as allowed: the server refuses with 403
 * anyway, and hiding on unknown would flash the actions away for everyone.
 */
export const useSellerCapabilities = () => {
  const { seller } = useMe()

  return {
    canCreateProducts: seller?.capabilities?.can_create_products ?? true,
    canCreateDigitalProducts:
      seller?.capabilities?.can_create_digital_products ?? true,
  }
}
